export default {
  state: {
    loading: false
  },
  mutations: {
    changeLoadingstate(state, value) {
      state.loading = value;
    }
  }
}